import routes from '@/router/routes/routeNames';
import type {
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  RouterScrollBehavior,
} from 'vue-router';

/**
 * Emulates native browser scrolling behaviour in Single-Page Applications
 * https://router.vuejs.org/guide/advanced/scroll-behavior#Scroll-Behavior
 * @param to - to
 * @param from - from
 * @param savedPosition - savedPosition
 */
const scrollBehavior = ((
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  savedPosition: {
    behavior?: ScrollOptions['behavior'];
    left: number;
    top: number;
  },
) => {
  // Simulate the "scroll to anchor" behavior
  if (to.hash) {
    return { el: to.hash, behavior: 'smooth' };
  }

  if (
    [to.name, from.name].every((name) => name === routes.insights) &&
    to.query.page !== from.query.page
  ) {
    return;
  }

  // Return the savedPosition for a native-like behavior when navigating with back/forward buttons,
  if (savedPosition) {
    return savedPosition;
  }

  // Otherwise, scroll to top for all route navigations
  return { left: 0, top: 0, behavior: 'smooth' };
}) as RouterScrollBehavior;

export default scrollBehavior;
